<blaze-availability-schedule-header
  [config]="config()"
  [isFirst]="isFirst()"
  [isExpanded]="isExpanded()"
  [canSave]="canSave()"
  [hasErrors]="hasErrors() ?? false"
  [hasMissingConfig]="hasMissingConfig()"
  [ruleErrors]="errors()?.ruleErrors ?? {}"
  (saveChanges)="onSaveChanges()"
  (toggleRules)="isExpanded.set(!isExpanded())"
  (copySchedule)="copySchedule.emit()"
  (updateConfig)="onConfigUpdate($event)"
  (deleteSchedule)="deleteSchedule.emit()"
/>
@if (isExpanded()) {
  <section class="flex flex-col gap-8">
    @for (rule of config().rules; track $index; let ruleIndex = $index) {
      <blaze-availability-schedule-rule
        [config]="config()"
        [rule]="rule"
        [ruleIndex]="ruleIndex"
        [errors]="errors()?.slotsErrors?.[ruleIndex] ?? []"
        [defaultTimeSlot]="defaultTimeSlot()"
        [visibleDays]="visibleDays()"
        (copySlots)="onCopySlots(rule, $event)"
        (updateConfig)="onConfigUpdate($event)"
      />
    }
  </section>
}
